import React from 'react';

export const buildMockMerchantData = (
  args?: Partial<IMerchantDataContext>,
): IMerchantDataContext => ({
  businessName: 'connected_account_business_name_value',
  country: 'US',
  defaultCurrency: 'usd',
  platformId: 'acct_9876543210',
  merchantId: 'acct_1234567890',
  livemode: true,
  publishableKey: 'pk_test_123',
  applicationName: 'application_name_value',
  platformBusinessName: 'platform_business_name_value',
  platformNickname: 'platform_nickname_value',
  showSupportLinks: true,
  ...args,
});

export type IMerchantDataContext = {
  businessName: string | undefined;
  country: string;
  defaultCurrency: string;
  merchantId: string;
  platformId: string | undefined;
  livemode: boolean;
  publishableKey: string;
  applicationName: string | undefined;
  platformNickname: string | undefined;
  platformBusinessName: string | undefined;
  showSupportLinks: boolean;
};

export const MerchantDataContext = React.createContext<
  IMerchantDataContext | undefined
>(undefined);
MerchantDataContext.displayName = 'MerchantDataContext';

export const useMerchantData = (): IMerchantDataContext | undefined => {
  const dataContext = React.useContext(MerchantDataContext);

  return dataContext!;
};
